import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';

// Interfaces
import { ICustomPage } from '../interfaces/ICustomPage';

@Injectable()
@ResourceParams({
    url: environment.url.api,
    pathPrefix: '/api/customPage'
})
export class CustomPageService extends RestClient {

    @ResourceAction({
        path: '/helpLine'
    })
    getHelpLine: IResourceMethod<{}, ICustomPage>;

    @ResourceAction({
        path: '/localResources'
    })
    getLocalResources: IResourceMethod<{}, ICustomPage>;

    @ResourceAction({
        path: '/learnAboutIO'
    })
    getLearnAboutIo: IResourceMethod<{}, ICustomPage>;

    @ResourceAction({
        path: '/incrementview/{:name}'
    })
    incrementView: IResourceMethod<{ name: any }, ICustomPage>;
}
